module.exports = __webpack_public_path__ + "img/soBHXH.fbe15dc0.jpg";